import { useFormContext } from 'react-hook-form'

import { InputInfoSM } from '@apps-common/components/elements'
import { commonIcons } from '@apps-common/config/icons'
import { IActivationServiceRequestCreateModel } from '@apps-common/types/portal/service-request'

interface IProps {
  loading?: boolean
  updating?: boolean
}

export const ActivationCompanyView: React.FC<IProps> = ({ loading, updating }) => {
  const { getValues } = useFormContext<IActivationServiceRequestCreateModel>()

  const { mCentre, bureau, tech } = getValues()

  return (
    <InputInfoSM
      id='company'
      hideNoEditIcon
      showLabel
      label='Company'
      value={
        <div className='relative min-w-[140px] rounded-3xl text-[0.9em] px-5 py-4 text-left bg-surface-2 border border-border'>
          <InputInfoSM
            id='mCentre'
            hideNoEditIcon
            showLabel
            label='Monitoring centre'
            value={mCentre}
            loading={loading}
            labelClassName='!p-0'
          />
          <InputInfoSM
            id='bureau'
            hideNoEditIcon
            showLabel
            label='Bureau'
            value={bureau && bureau?.length > 0 ? bureau : <commonIcons.dash />}
            loading={loading}
            labelClassName='!p-0'
          />
          <InputInfoSM
            id='tech'
            hideNoEditIcon
            showLabel
            label='Technician'
            value={tech && tech?.length > 0 ? tech : <commonIcons.dash />}
            loading={loading}
            labelClassName='!p-0'
          />
        </div>
      }
      className='border-none !p-0 !opacity-100'
    />
  )
}
